export function readableBytes(bytes: string): string {
  const units = ['Bytes', 'KB', 'MB', 'GB'];

  units.forEach(unit => {
    if (!isNaN(+bytes)) {
      bytes = +bytes < 500 ? `${bytes} ${unit}` : (parseFloat(bytes) / 1000).toFixed(2);
    }
  });

  return bytes;
}
